/**
 * Enter 键的 keycode
 */
export const KEY_CODE_ENTER = 13;

/**
 * Backspace 键的 keycode
 */
export const KEY_CODE_BACKSPACE = 8;

/**
 * 统一样式前缀
 */
export const CLASSNAME_PREFIX = "ct";
export const PARKER_CLASSNAME_PREFIX = "pk";

/**
 * 零宽度空格
 */
export const ZERO_WIDTH_SPACE = "\u200B";

/**
 * @ 的物理 code 值
 */
export const CODE_AT = "Digit2";
